<template>
  <div>
    <Header :right-sidebar="true" right-sidebar-title="Профсоюзы">
      <template #right-sidebar>
        <sidebar-items-group title="Отображать столбцы">
          <fields-picker
            v-model="pickedFields"
            :fields="displayableServicesFields"
          />
        </sidebar-items-group>
        <sidebar-items-group title="Фильтры">
          <filters-group
            :fields="servicesFields"
            :items="services"
            v-model="filteredItems"
          />
        </sidebar-items-group>
        <sidebar-item variant="success" :to="`/employees/services/create`">
          Добавить службу
          <template #icon>
            <b-icon icon="plus-square" />
          </template>
        </sidebar-item>
      </template>
    </Header>
    <Main>
      <b-table
        selectable
        select-mode="single"
        :busy="!loaded"
        :responsive="true"
        :items="paintedRows"
        :fields="pickedFields"
        @row-clicked="item => openService(item)"
        hover
        class="table-rounded"
        empty-text="Записей нет"
      />
    </Main>
  </div>
</template>
<script>
import Header from "@/components/Layout/Header";
import SidebarItemsGroup from "@/components/Layout/Sidebars/SidebarItems/SidebarItemsGroup";
import FieldsPicker from "@/components/Tables/FieldsPicker";
import FiltersGroup from "@/components/Tables/Filters/FiltersGroup";
import SidebarItem from "@/components/Layout/Sidebars/SidebarItems/SidebarItem";
import Main from "@/components/Layout/Main";
import { displayableFields } from "@/components/Tables/defaultFields";
import { defaultRowPainter } from "@/components/Tables/rowPainters";
import { mapGetters } from "vuex";
import { servicesFields } from "@/views/Services/models/servicesTableModel";
import pageTitleMixin from "@/mixins/pageTitleMixin";

export default {
  components: {
    Main,
    SidebarItem,
    FiltersGroup,
    FieldsPicker,
    SidebarItemsGroup,
    Header
  },
  mixins: [pageTitleMixin],
  data() {
    let displayableServicesFields = displayableFields(servicesFields);
    return {
      servicesFields,
      displayableServicesFields,
      professionalGroups: [],
      filteredItems: [],
      pickedFields: displayableServicesFields
    };
  },
  computed: {
    ...mapGetters("services", ["services", "loaded"]),
    paintedRows: ({ filteredItems }) => defaultRowPainter(filteredItems)
  },
  methods: {
    openService({ id }) {
      this.$router.push(`/employees/services/${id}`);
    }
  }
};
</script>
